import { getUxAttribution } from '../utils/uxTracker.js';
import { attributionReferrer } from './acquisitionAttribution.js';

// GH-1131: the same channel taxonomy as auth-worker's deriveSignupChannel
// (src/signup-channel.ts): google_ads | organic | chatgpt | claude | shopify |
// web | unknown. Analytics only — the `source` prop on client funnel events.
// chatgpt / shopify / unknown keep their meaning; the former `web` bucket is
// split into google_ads / organic / claude / chatgpt (AI-search referrals).
const GOOGLE_ADS_SOURCES = new Set(['google', 'adwords', 'googleads', 'google_ads', 'google-ads']);
const PAID_MEDIUMS = new Set(['cpc', 'ppc', 'paid', 'paidsearch', 'paid_search', 'paid-search', 'sem', 'ads', 'cpm', 'display', 'pmax']);
const CLAUDE_SOURCES = new Set(['claude', 'claude.ai', 'anthropic']);
const CHATGPT_SOURCES = new Set(['chatgpt.com', 'openai']);

const CLAUDE_HOST = /(^|\.)(claude\.ai|claude\.com|anthropic\.com)$/;
const CHATGPT_HOST = /(^|\.)(chatgpt\.com|openai\.com)$/;
const GOOGLE_ADS_HOST = /(^|\.)(googleadservices\.com|doubleclick\.net|googlesyndication\.com)$/;
// Web search result pages only — mail/docs/accounts.google.com are not search.
const SEARCH_HOST = /^(www\.)?google\.[a-z]{2,3}(\.[a-z]{2})?$|(^|\.)(bing\.com|duckduckgo\.com|search\.yahoo\.com|yandex\.[a-z]{2,3}|ecosia\.org|baidu\.com|search\.brave\.com|startpage\.com|qwant\.com|seznam\.cz|naver\.com)$/;

function externalReferrerHost(referrer) {
  try {
    const host = new URL(attributionReferrer(referrer)).hostname.toLowerCase();
    const own = /(^|\.)dathent\.(ai|com)$/.test(host)
      || ['localhost', '127.0.0.1'].includes(host)
      || /(^|\.)(app-lending(?:-staging|-dev)?|dathent-ai(?:-staging|-dev)?)\.pages\.dev$/.test(host);
    return own ? null : host;
  } catch { return null; }
}

export function deriveFunnelSource({
  landingPath = null, utmSource = null, utmMedium = null, referrer = null, googleClickId = false,
} = {}) {
  const path = String(landingPath || '').toLowerCase();
  const utm = String(utmSource || '').trim().toLowerCase();
  const medium = String(utmMedium || '').trim().toLowerCase();
  if (path.includes('oauth-mcp') || utm === 'chatgpt') return 'chatgpt';
  if (path.startsWith('/shopify')) return 'shopify';
  const host = externalReferrerHost(referrer);
  if (googleClickId === true
    || (GOOGLE_ADS_SOURCES.has(utm) && (!medium || PAID_MEDIUMS.has(medium)))
    || (host && GOOGLE_ADS_HOST.test(host))) return 'google_ads';
  if (CLAUDE_SOURCES.has(utm) || (host && CLAUDE_HOST.test(host))) return 'claude';
  if (CHATGPT_SOURCES.has(utm) || (host && CHATGPT_HOST.test(host))) return 'chatgpt';
  if (medium === 'organic' || (!utm && host && SEARCH_HOST.test(host))) return 'organic';
  return utm || host ? 'web' : 'unknown';
}

export function getFunnelSource() {
  try {
    return deriveFunnelSource(getUxAttribution());
  } catch {
    return 'unknown';
  }
}
